import cn from 'classnames'
import styled from 'styled-components'

import theme, { rem } from '../../utils/theme'
import Content from './components/Content'
import DeviceWrap from './components/DeviceWrap'
import Header from './components/Header'

const StyledRegoFormPreview = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${rem(30)};
  background-color: ${`var(--gameday-regoForm-previewBg, ${theme.regoForm.previewBg})`};
  border-radius: 4px;

  * {
    transition: ${theme.transitions.smooth};
  }
`

const RegoFormPreview = ({
  buttonColor,
  buttonTextColor,
  logo,
  navColor,
  navLogo,
  textcolor,
  type,
  viewMobile,
  primaryGradient,
  secondaryGradient,
  noBgGradient,
}) => (
  <StyledRegoFormPreview className={cn(viewMobile && 'view-mobile')}>
    <DeviceWrap>
      <Header logo={logo} navColor={navColor} navLogo={navLogo} textcolor={textcolor} type={type} />
      <Content
        buttonColor={buttonColor}
        buttonTextColor={buttonTextColor}
        navColor={navColor}
        textcolor={textcolor}
        viewMobile={viewMobile}
        primaryGradient={primaryGradient}
        secondaryGradient={secondaryGradient}
        noBgGradient={noBgGradient}
      />
    </DeviceWrap>
  </StyledRegoFormPreview>
)

RegoFormPreview.defaultProps = {
  buttonColor: '',
  buttonTextColor: '',
  logo: '',
  navColor: '',
  navLogo: '',
  textcolor: '',
  type: 'membership',
  viewMobile: false,
}

export default RegoFormPreview
